import { useTheme } from "components/ListingNew/ListingTheme";

interface MapProps {
	latitude: number;
	longitude: number;
}

// Return a IFrame with the google map
export const MapElement = ({ latitude, longitude }: MapProps): JSX.Element => {
	// const theme = useTheme();
	return (
		<iframe
			src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
			loading="eager"
			title="map"
			referrerPolicy="no-referrer-when-downgrade"
			allowFullScreen
			style={{
				// filter: theme?.mapBackground,
				width: "100%",
				border: "none",
				height: "231px",
				borderRadius: "10px",
			}}
		/>
	);
};

export const getDirectionURL = (
	latitude: number,
	longitude: number,
): string => {
	return `https://maps.google.com/maps/dir//${latitude},${longitude}/@${latitude},${longitude},15z`;
};
